// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"roles_wrapper_1eJ9PbN","tabHeader":"roles_tabHeader_2NTCDjP","tabTitle":"roles_tabTitle_2YUtUMO"};